import {BrowserModule} from '@angular/platform-browser';
import {Injector, NgModule} from '@angular/core';
import {ServiceLocator} from '../services/locator.service';

/***    ANGULAR MATERIAL IMPORT    ***/
// animations

// components
import {
    MatIconModule,
    MatButtonModule,
    MatMenuModule,
    MatToolbarModule,
    MatTableModule,
    MatCardModule,
    MatTooltipModule,
    MatPaginatorModule, MatProgressBarModule, MatDialogModule, MatExpansionModule, MatFormFieldModule,
    MatInputModule, MatSlideToggleModule, MatSortModule, MatTabsModule, MatAutocompleteModule, MatRadioModule, MatDatepickerModule,
    MatSelect, MatSelectModule, MatMenuTrigger,
} from '@angular/material';
/***    ANGULAR MATERIAL IMPORT    ***/

import {RouterModule} from '@angular/router';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {PipesModule} from '../pipes/pipes.module';
import {ContractsListComponent} from './ContractsListComponent/contracts-list.component';
import {ContractService} from '../services/contract.service';
import {ContractEditComponent} from './ContractEditComponent/contract-edit.component';
import {NgbTimepickerModule} from '@ng-bootstrap/ng-bootstrap';
import {DatetimeTermpickerComponent} from '../SharedModule/DatetimeTermpickerComponent/datetime-termpicker.component';
import {SharedModule} from '../SharedModule/shared.module';
import {ContractDetailComponent} from './ContractDetailComponent/contract-detail.component';
import {MomentModule} from 'angular2-moment';
import {ContractItemService} from '../services/contract-item.service';
import {ContractItemsListComponent} from './ContractItemsListComponent/contract-items-list.component';
import {ContractItemsTransferDialogComponent} from './ContractItemsTransferDialogComponent/contract-items-transfer.dialog.component';
import {ContractItemsTransferListComponent} from './ContractItemsTransferListComponent/contract-items-transfer-list.component';
import {ContractItemTransferService} from '../services/contract-item-transfer.service';
import {SingleContractItemTransferDialogComponent} from './SingleContractItemTransferDialogComponent/single-contract-item-transfer.dialog.component';
import {ContractItemSplitDialogComponent} from './ContractItemSplitDialogComponent/contract-item-split.dialog.component';
import {ContractMailDialogComponent} from './ContractMailDialogComponent/contract-mail.dialog.component';
import {EditorModule} from '@tinymce/tinymce-angular';
import {ContractItemAvailabilityDialogComponent} from './ContractItemAvailabilityDialogComponent/contract-item-availability.dialog.component';
import {DirectivesModule} from '../directives/directives.module';
import {ContractEventService} from '../services/event.service';
import {ContractEventDialogComponent} from './ContractEventDialogComponent/contract-event.dialog.component';
import {ContractStateChangeConfirmDialogComponent} from './ContractStateChangeConfirmDialogComponent/contract-state-change-confirm.dialog.component';
import {DragulaModule} from 'ng2-dragula';
import {ContractDeleteConfirmDialogComponent} from './ContractDeleteConfirmDialogComponent/contract-delete-confirm.dialog.component';
import {ContractGroupItemLossDialogComponent} from './ContractGroupItemLossDialogComponent/contract-group-item-loss.dialog.component';
import {ContractGroupItemLossListComponent} from './ContractGroupItemLossListComponent/contract-group-item-loss-list.component';
import {TransportDialogComponent} from './TransportDialogComponent/transport.dialog.component';
import {TransportService} from '../services/transport.service';
import {TransportDeleteConfirmDialogComponent} from './TransportDeleteConfirmDialogComponent/transport-delete-confirm.dialog.component';
import {ContractConfirmMissingTransportDialogComponent} from './ContractConfirmMissingTransportDialogComponent/contract-confirm-missing-transport.dialog.component';
import {ContractStateComponent} from '../SharedModule/ContractStateComponent/contract-state.component';
import {ContractState} from '../model/Entities/ContractState';
import {DocumentListComponent} from '../DocumentsModule/DocumentListComponent/document-list.component';
import {DocumentsModule} from '../DocumentsModule/documents.module';


@NgModule({
    declarations: [
        ContractsListComponent,
        ContractDetailComponent,
        ContractEditComponent,
        ContractItemsListComponent,
        ContractItemsTransferDialogComponent,
        ContractItemsTransferListComponent,
        ContractGroupItemLossListComponent,
        SingleContractItemTransferDialogComponent,
        ContractItemSplitDialogComponent,
        ContractMailDialogComponent,
        ContractItemAvailabilityDialogComponent,
        ContractEventDialogComponent,
        ContractStateChangeConfirmDialogComponent,
        ContractDeleteConfirmDialogComponent,
        TransportDeleteConfirmDialogComponent,
        ContractConfirmMissingTransportDialogComponent,
        ContractGroupItemLossDialogComponent,
        TransportDialogComponent,
    ],
    imports: [
        BrowserModule,
        RouterModule,
        FormsModule,
        ReactiveFormsModule,
        EditorModule,
        DirectivesModule,
        DragulaModule,
        DocumentsModule,

        // Angular Material components
        MatAutocompleteModule,
        MatButtonModule,
        MatCardModule,
        MatDatepickerModule,
        MatDialogModule,
        MatExpansionModule,
        MatFormFieldModule,
        MatIconModule,
        MatInputModule,
        MatMenuModule,
        MatPaginatorModule,
        MatProgressBarModule,
        MatRadioModule,
        MatSelectModule,
        MatSlideToggleModule,
        MatSortModule,
        MatTableModule,
        MatTabsModule,
        MatToolbarModule,
        MatTooltipModule,
        NgbTimepickerModule,
        MomentModule,
        PipesModule,
        SharedModule
    ],
    exports: [
        ContractsListComponent
    ],
    entryComponents: [
        ContractItemsTransferDialogComponent,
        SingleContractItemTransferDialogComponent,
        ContractItemSplitDialogComponent,
        ContractMailDialogComponent,
        ContractItemAvailabilityDialogComponent,
        ContractEventDialogComponent,
        ContractStateChangeConfirmDialogComponent,
        ContractDeleteConfirmDialogComponent,
        TransportDialogComponent,
        TransportDeleteConfirmDialogComponent,
        ContractConfirmMissingTransportDialogComponent,
        ContractGroupItemLossDialogComponent,
        ContractStateComponent
    ],
    providers: [
        ContractService,
        ContractItemService,
        TransportService,
        ContractItemTransferService,
        ContractEventService
    ]
})
export class ContractsModule {

    constructor(private injector: Injector) {  // Create global Service Injector.
        ServiceLocator.injector = this.injector;
    }
}



// WEBPACK FOOTER //
// /app/src/ContractsModule/contracts.module.ts